import React from "react";
import { Link } from 'react-router-dom';
import CareerForm from "./CareerForm";


function Career() {
    return (
        <>
            <header>
                <div className="container mt-5">
                    <div className="page-banner">
                        <div className="row justify-content-center align-items-center h-100">
                            <div className="col-md-6">
                                <nav aria-label="Breadcrumb">
                                    <ul className="breadcrumb justify-content-center py-0 bg-transparent">
                                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item active">Careers</li>
                                    </ul>
                                </nav>
                                <h1 className="text-center">Careers</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <div className="back-to-top"></div>
            <main>
                <div className="page-section">
                    <div className="container">
                        <div className="row">
                            <CareerForm />
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}

export default Career;
